const selectThis = (state) => {
  return state.activeProject.survey;
};

export const selectIsDqaEnabled = (state): boolean => {
  return !!selectThis(state).dqa;
};

export const selectIsNextButtonEnabled = (state): boolean => {
  return !!selectThis(state).enableNextButton;
};
